import { useState } from 'react'

import type { AnalyticsTrackingView } from './AnalyticsTracker.types'

type AnalyticsIdentity = Pick<
  AnalyticsTrackingView,
  'userId' | 'organizationId' | 'originalOrganizationId'
>

/**
 * Auth pages keep the identity they started with until the user leaves them.
 * Signing in on /login must not end that view and send a second page_view
 * before the redirect.
 * Pass `null` whenever the view isn't being measured (not an auth page, or
 * tracking off) to follow the current identity; the next key captures anew.
 */
export const useAuthViewIdentity = (
  authViewKey: string | null,
  identity: AnalyticsIdentity
): AnalyticsIdentity => {
  const [started, setStarted] = useState({ key: authViewKey, identity })
  if (started.key !== authViewKey) {
    // React re-renders before committing, so this pass is never shown.
    setStarted({ key: authViewKey, identity })
    return identity
  }
  return authViewKey === null ? identity : started.identity
}
